// copied from apps/crm; consolidate into a shared package in S5 slice 4
// The test-set header is honoured for staff only (ADR-006); an installer session
// never carries one, but the api client accepts the hook so the seam stays identical.
const KEY = "aiw.installer.testSet";

export function getTestSet(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}
export function setTestSet(id: string | null): void {
  try { id ? localStorage.setItem(KEY, id) : localStorage.removeItem(KEY); } catch { /* private mode */ }
  window.dispatchEvent(new Event("aiw:testset"));
}
